'use es6';

import getLang from 'I18n/utils/getLang';
import { http } from '../features/http';
import { quickFetchOrGet, getCachedThenNew } from '../utils/ajaxUtils';
import { BASE_URI_LC } from '../constants/ApiConstants';
export const LESSON_API_URL = `${BASE_URI_LC}/lessons`;
export const fetchAvailableLanguagesByLessonId = lessonId => http.get(`${LESSON_API_URL}/${lessonId}/available-languages`);
export function fetchAllPublicLessons(onSuccess, onError, language) {
  return getCachedThenNew(`lessons-${language}`, `${LESSON_API_URL}/${language}?fallbackLanguage=en`, {
    onSuccess,
    onError
  });
}
export const fetchAllPartnerLessons = ({
  language = getLang()
}) => quickFetchOrGet(`partner-lessons-${language}`, `${LESSON_API_URL}/partners/${language}?fallbackLanguage=en`, {});